var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgManage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "#FFF",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 6c1.657 0 3 1.343 3 3h1c1.657 0 3 1.343 3 3v14c0 1.657-1.343 3-3 3H12c-1.657 0-3-1.343-3-3V12c0-1.657 1.343-3 3-3h1c0-1.657 1.343-3 3-3zm1 14h-6c-.552 0-1 .448-1 1 0 .513.386.936.883.993L15 22h6c.552 0 1-.448 1-1s-.448-1-1-1zm-2-4h-4c-.552 0-1 .448-1 1 0 .513.386.936.883.993L15 18h4c.552 0 1-.448 1-1s-.448-1-1-1zm1-8h-4c-.552 0-1 .448-1 1v1h6V9c0-.552-.448-1-1-1z",
    transform: "translate(-119 -1177) translate(81 734) translate(38 443)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManage);
export default __webpack_public_path__ + "static/media/manage.982c48264910aed77ce23369d876ad14.svg";
export { ForwardRef as ReactComponent };